import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CabsandJobcardPage } from './cabsand-jobcard';

@NgModule({
  declarations: [
    CabsandJobcardPage,
  ],
  imports: [
    IonicPageModule.forChild(CabsandJobcardPage),
  ],
})
export class CabsandJobcardPageModule {}



// WEBPACK FOOTER //
// ./src/pages/cabsand-jobcard/cabsand-jobcard.module.ts